export default __webpack_public_path__ + "static/media/illustration-lifestyle.91a08688.svg";